import styled from "styled-components/macro";
import { Modal as AntModal } from "antd";
import { typography } from "src/utils/styledComponents/typography";
import { colors } from "src/theme/colors";

/**
 * The dialog most of the dashboard's popups are built on.
 *
 * Its chrome now comes from the shared dialog rules in GlobalStyle, which a
 * dialog opts into with a fina-dialog class on its wrap. What was declared
 * here beat those rules on specificity and kept the old look wherever it was
 * used: a 12px card ringed in a full-strength accent border, a head with no
 * rule under it, a body with no padding, and a close control drawn as a
 * filled red disc — which, once the shared rules gave the close control a
 * square, showed up as a red disc sitting inside that square.
 *
 * What remains is the body typography and the two props callers set.
 */
export const Modal = styled(AntModal)<{
  visibleHeader?: boolean;
  disableCancel?: boolean;
  contentPadding?: string;
}>`
  &.ant-modal {
    ${typography.CustomText("1em")}

    .ant-modal-content {
      ${(props) =>
        props.contentPadding ? `padding: ${props.contentPadding};` : ""}
    }

    .ant-modal-header {
      display: ${(props) => (!props.visibleHeader ? "none" : "block")};
    }

    .ant-modal-close {
      display: ${(props) => (props.disableCancel ? "none" : "block")};
    }
  }
`;

/**
 * The dialog's title.
 *
 * It was a 1.5em accent-blue serif with a top margin, centred — a heading
 * with more presence than the dialog it named, in a face used nowhere else in
 * the product. Size, weight, colour and alignment come from the shared rules
 * now; this only has to stop imposing a font and a margin of its own.
 */
export const Header = styled.div`
  color: ${colors.gray[900]};
`;
